import gql from 'graphql-tag';

export const mutationSendOtherProviderRequest = gql`
  mutation sendOtherProviderRequest (
    $request: String!
  ) {
    sendOtherProviderRequest (
      request: $request
    )
  }
`;
export default mutationSendOtherProviderRequest;
